// ============================================================================
// Tipos de notificación
// ============================================================================

export type TipoNotificacion = 'campania_enviada' | 'campania_vencida' | 'estado_cambiado'

export const TIPOS_NOTIFICACION: { value: TipoNotificacion; label: string }[] = [
  { value: 'campania_enviada', label: 'Campaña Enviada' },
  { value: 'campania_vencida', label: 'Campaña Vencida' },
  { value: 'estado_cambiado', label: 'Estado Cambiado' },
]

export type EstadoLectura = 'leidas' | 'no_leidas' | ''

// ============================================================================
// Campaña embebida
// ============================================================================

export interface CampaniaResumen {
  id: number
  nombre_campania: string
  marca: string
  marca_secundaria: string | null
  fecha_publicacion: string | null  // formato dd/mm/yyyy
  hora: string | null               // formato HH:MM
}

// ============================================================================
// Notificación completa (historial)
// ============================================================================

export interface Notificacion {
  id: number
  tipo: TipoNotificacion
  titulo: string
  mensaje: string
  url: string
  leida_por_usuario: boolean
  fecha_creacion: string
  fecha_lectura: string | null
  campania: CampaniaResumen
}

// ============================================================================
// Notificación simplificada (dropdown)
// ============================================================================

export interface NotificacionSimple {
  id: number
  tipo: TipoNotificacion
  titulo: string
  url: string
  leida_por_usuario: boolean
  fecha_creacion: string
  campania_id: number
  campania_nombre: string
  campania_marca: string
  campania_marca_secundaria: string | null
  campania_fecha: string | null
  campania_hora: string | null
}

// ============================================================================
// Respuestas paginadas
// ============================================================================

export interface NotificacionesPaginadas {
  count: number
  page: number
  page_size: number
  total_pages: number
  results: Notificacion[]
}

export interface NotificacionesDropdown {
  notificaciones: NotificacionSimple[]
  contador: number
  total: number
}

export interface NotificacionesStats {
  total: number
  no_leidas: number
  leidas: number
}

// ============================================================================
// Filtros
// ============================================================================

export interface FiltrosNotificaciones {
  search?: string
  fecha_desde?: string
  fecha_hasta?: string
  tipo?: TipoNotificacion | ''
  leida?: EstadoLectura
  page?: number
  page_size?: number
}

// ============================================================================
// Respuestas de acciones
// ============================================================================

export interface MarcarLeidaResponse {
  success: boolean
  message: string
  contador: number
}

export interface MarcarTodasLeidasResponse {
  success: boolean
  message: string
  marcadas: number
  contador: number
}
